import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  percent: number;
}

export default function ProgressBar({ percent }: ProgressBarProps) {
  return (
    <div className={styles.track}>
      <div className={styles.bar} style={{ width: `${percent}%` }} />
    </div>
  );
}
